import React, { useMemo } from 'react'
import styled from 'styled-components'
import Link from '~/prix/react/components/link'
import useAPI from '~/prix/react/hooks/api'
import LinkArrowIcon from '~/meta/linkArrow.svg'

const Items = styled.ul`
  margin: 0;
  padding: 16px 32px 24px 32px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0px 32px 30px rgba(20, 46, 82, 0.2);
  border-radius: 0 0 12px 12px;
`

const Item = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #e0e5eb;
    padding: 20px 0;
    width: 100%;
    flex: 1;

    svg {
      margin-right: 10px;
      min-width: 24px;
      min-height: 24px;
      transition: transform 0.2s ease-in-out;
    }

    color: #617385;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px;

    &:hover {
      color: #0f438a;

      svg {
        transform: translateX(5px);
      }
    }
  }

  &:last-child {
    a {
      border-bottom: none;
    }
  }
`

export default function StudyGridItemShortcuts() {
  const { context } = useAPI()

  // const agentPermission = useMemo(() => {
  //   return context.user?.roles.includes('agent')
  // }, [context.user])

  return (
    <Items>
      <Item>
        <Link href='/app/disproportionate-attention'>
          <LinkArrowIcon />
          ATENDIMENTO DESPROPORCIONAL
        </Link>
      </Item>
      <Item>
        <Link href='/app/map/demarcation'>
          <LinkArrowIcon />
          MAPA DE DEMARCAÇÃO
        </Link>
      </Item>
      <Item>
        <Link href='/app/agent-report'>
          <LinkArrowIcon />
          RELATÓRIO DO AGENTE
        </Link>
      </Item>
      <Item>
        <Link href='/app/time-series/'>
          <LinkArrowIcon />
          SÉRIES TEMPORAIS
        </Link>
      </Item>
      <Item>
        <Link href='/app/map/'>
          <LinkArrowIcon />
          OUTROS MAPAS
        </Link>
      </Item>
    </Items>
  )
}
